import ScrollLocker from "./ScrollLocker";
import gsap from "gsap";


export default class ProductModalController {
    constructor() {
        this.DOM = {};
        this.popupWrapper = document.querySelector('.js-product-modal-wrapper');
        this.closeButton = document.querySelectorAll('.js-product-modal-close');
        this.scrollLock = new ScrollLocker();

        if (this.popupWrapper) {
            this.init();
        }
    }

    init() {
        this.closeButton.forEach(button => {
            button.addEventListener('click', () => {
                this.hideModal();
            });
        });

    }

    showModal() {
        gsap.to(this.popupWrapper, {
            autoAlpha: 1,
            duration: 0.5,
            onComplete: () => {
                this.scrollLock.lockScroll();
            }
        });
    }

    hideModal() {
        gsap.to(this.popupWrapper, {
            autoAlpha: 0,
            duration: 0.5,
        });
        this.scrollLock.unlockScroll();

        let currentUrl = window.location.href;
        let urlWithoutParameters = currentUrl.split('?')[0];

        history.pushState(null, '', urlWithoutParameters);
    }

}
